import { Classes, Dialog } from "@blueprintjs/core";
import { FGTextInput, FieldGroup } from "nsitools-react";
import * as React from "react";
import styled from "styled-components";
import * as Yup from "yup";

import { SiegeSocialFichierApi, SiegeSocialFichierDto } from "../../../../../api";
import { FGWalterSelectInput, SmallFormGenerator } from "../../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../../hooks";
import { useReferential } from "../../../../../hooks/useReferential";
import { ETLCodes } from "../../../../../locales";

const StyledDialog = styled(Dialog)`
  width: 600px;
  height: auto;
  background-color: white;
`;

export interface ISiegeSocialDocumentEditDialogProps {
  idsiegeSocialFichier: number;
  onClose: (refresh?: boolean) => void;
}

export const SiegeSocialDocumentEditDialog: React.FunctionComponent<ISiegeSocialDocumentEditDialogProps> = ({
  idsiegeSocialFichier,
  onClose
}) => {
  const { t } = useTl();
  const api = useApiService(SiegeSocialFichierApi);

  const { data, loading, saveItem, saving, validationErrors } = useCrudApi(
    React.useMemo(
      () => ({
        getApiFn: () => {
          return api.siegeSocialFichierGetSiegeSocialFichier({ id: idsiegeSocialFichier });
        },
        saveApiFn: async (d: SiegeSocialFichierDto) => {
          return api.siegeSocialFichierSaveSiegeSocialFichier({ SiegeSocialFichierDto: d });
        },
        onSaved: () => onClose(true)
      }),
      [api, idsiegeSocialFichier, onClose]
    )
  );

  const FormSchema = React.useMemo(
    () =>
      Yup.object().shape({
        idtypeSiegeSocialFichier: Yup.number()
          .nullable()
          .required(t(ETLCodes.Required))
      }),
    [t]
  );

  const [typesSiegeSocialFichier, tLoading] = useReferential(a => a.referentialGetTypesSiegeSocialFichier());

  return (
    <StyledDialog title={t(ETLCodes.UploadFichier)} isOpen={!!idsiegeSocialFichier} onClose={() => onClose(false)}>
      <div className={Classes.DIALOG_BODY}>
        <SmallFormGenerator
          initialValues={data}
          onSubmit={saveItem}
          editMode={true}
          validationSchema={FormSchema}
          onCancel={() => onClose(false)}
          showDeleteButton={false}
          saving={saving}
          loading={loading}
          validationErrors={validationErrors}
        >
          <FieldGroup>
            <FGTextInput name="fileName" label={t(ETLCodes.Fichier)} readonly />
            <FGWalterSelectInput
              name="idtypeSiegeSocialFichier"
              label={t(ETLCodes.Type)}
              items={typesSiegeSocialFichier}
              loading={tLoading}
            />
          </FieldGroup>
        </SmallFormGenerator>
      </div>
    </StyledDialog>
  );
};
